<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Manage Bookings</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <modal
        :show.sync="modals.showModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form">
              <base-input label="Status">
                <el-select
                  placeholder="Select status"
                  v-model="myObj.status"
                  v-bind:error="statusError"
                  filterable
                >
                  <el-option
                    v-for="option in selects.status"
                    class="select-danger"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <div>
                <base-button
                  @click="UpdateBooking()"
                  :disabled="updating"
                  type="primary"
                  class="col"
                  ><i v-bind:class="sign"></i> {{ optionName }}</base-button
                >
              </div>
            </form>
          </template>
        </card>
      </modal>

      <!--Classic modal-->
      <modal :show.sync="details">
        <template v-slot:header>
          <h6 class="modal-title">Appointment Details</h6>
        </template>

        <div v-for="item in bookingDetails" :key="item.message">
          <h2>{{ item.serviceName }} - {{ item.svTime }} mins</h2>
          <h4>{{ item.staff }} - {{ item.dTime }}</h4>
          <p>{{ item.category }}</p>
        </div>

        <template v-slot:footer>
          <base-button type="primary" @click="details = false">OK</base-button>
          <base-button type="link" class="ml-auto" @click="details = false"
            >Close</base-button
          >
        </template>
      </modal>

      <modal
        :show.sync="modals.showViewModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered "
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form">
              <label for="">Booking details</label>
              <div class="row">
                <div class="col-md-6">
                  <base-input
                    label="Booking ID:"
                    class="mb-3"
                    name="batch"
                    type="number"
                    v-model="myObj.bookingID"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="User ID:"
                    class="mb-3"
                    name="batch"
                    type="number"
                    v-model="myObj.userID"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Transcation ID:"
                    class="mb-3"
                    name="batch"
                    type="number"
                    v-model="myObj.transactionID"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Date:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.date"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Time:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.time"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Bill:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.bill"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Tax:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.tax"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Total amount:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.totalAmount"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Tip:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.tip"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Discount percentage:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.discountPercentage"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Discount Amount:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.discountAmount"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Promo code:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.promoCode"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Status:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.status"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Time value:"
                    class="mb-3"
                    name="batch"
                    type="text"
                    v-model="myObj.timeValue"
                    readonly
                  />
                </div>
              </div>
              <div>
                <base-button
                  @click="modals.showViewModal = false"
                  type="primary"
                  class="col"
                  >Close</base-button
                >
              </div>
            </form>
          </template>
        </card>
      </modal>
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header"> </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                hidden
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary pull-right"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column min-width="180px" align="right" label="Options">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click="showRecord($index, row)"
                    class="like btn-link"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white far fa-eye"></i>
                  </base-button>

                  <base-button
                    @click="editRecord($index, row)"
                    class="like btn-link"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white far fa-edit"></i>
                  </base-button>

                  <base-button
                    @click="handleDelete($index, row)"
                    class="like btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import moment from "moment";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  created() {
    this.LoadData();
  },
  data() {
    return {
      bookingDetails: [],
      details: false,
      myObj: {
        bookingID: 0,
        userID: 0,
        transactionID: 0,
        date: null,
        time: null,
        bill: null,
        tax: null,
        totalAmount: null,
        tip: null,
        discountPercentage: null,
        discountAmount: null,
        promoCode: "",
        status: "",
        timeValue: "",
        categoryID: 0,
      },
      selects: {
        status: [
          { value: "Scheduled", label: "Scheduled" },
          { value: "Completed", label: "Completed" },
        ],
      },
      propsToSearch: [
        "totalAmount",
        "discountPercentage",
        "promoCode",
        "status",
        "date",
      ],
      tableColumns: [
        {
          prop: "name",
          label: "Customer",
          minWidth: 200,
          sortable: true,
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 200,
          sortable: true,
        },
        {
          prop: "contact",
          label: "Contact",
          minWidth: 200,
          sortable: true,
        },
        {
          prop: "date",
          label: "date",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "time",
          label: "time",
          minWidth: 120,
          sortable: true,
        },

        {
          prop: "bill",
          label: "Total",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "tip",
          label: "Tip",
          minWidth: 160,
          sortable: true,
        },
        {
          prop: "status",
          label: "Status",
          minWidth: 120,
          sortable: true,
        },
      ],
      tableData: [],
      selectedRows: [],
      modals: {
        showModal: false,
        showViewModal: false,
      },
      optionName: "Updating status",
      name: "",
      prefixname: "",
      prefixError: false,
      fnError: false,
      statusError: false,
      sign: "",
      shouldAdd: true,
      eIndex: 0,
    };
  },
  methods: {
    LoadData() {
      var url = this.$store.state.domain + "/bookings";
      axios
        .get(url)
        .then((response) => {
          this.tableData = [];
          if (response.data.status === "error") {
          } else {
            response.data.forEach((element) => {
              if (element.bill !== null)
                element.bill = parseFloat(element.bill).toFixed(2);

              if (element.tip !== null)
                element.tip = parseFloat(element.tip).toFixed(0);

              if (element.date !== null || element.date !== "")
                element.date = moment(element.date).format("DD MMM YYYY, ddd");

              this.tableData.push(element);

              // //Load Time
              // axios.get(url + "/getTime/" + element.bookingID).then((res) => {
              //   //console.log("time", res.data.time);
              //   element.time = res.data.time;
              //   this.tableData.push(element);
              // });
            });
            // this.tableData = [];
            // this.tableData = response.data;
          }
        })
        .catch(function (error) {});
    },
    LoadByID() {
      var url = this.$store.state.domain + "/bookings/" + this.myObj.bookingID;
      axios
        .get(url)
        .then((response) => {
          if (response.data.status === "error") {
          } else {
            this.viewData = response.data;
          }
        })
        .catch(function (error) {});
    },
    UpdateBooking() {
      var url = this.$store.state.domain + "/bookings/status";
      axios
        .put(url, {
          bookingID: this.myObj.bookingID,
          status: this.myObj.status,
        })
        .then((response) => {
          console.log(response);
          if (response.data.affectedRows === 0) {
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + "Something went wrong",
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showModal = false;
            this.LoadData();
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br /> booking status updated.",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        });
      this.optionName = "Update Status";
      this.modals.showModal = false;
    },
    viewRecord(index, row) {
      this.eIndex = index;
      this.myObj.bookingID = row.bookingID;
      this.myObj.userID = row.userID;
      this.myObj.transactionID = row.transactionID;
      this.myObj.date = row.date;
      this.myObj.time = row.time;
      this.myObj.bill = row.bill;
      this.myObj.tax = row.tax;
      this.myObj.totalAmount = row.totalAmount;
      this.myObj.tip = row.tip;
      this.myObj.discountPercentage = row.discountPercentage;
      this.myObj.discountAmount = row.discountAmount;
      this.myObj.promoCode = row.promoCode;
      this.myObj.status = row.status;
      this.myObj.timeValue = row.timeValue;
      this.shouldAdd = false;
      this.optionName = "Update";
      this.modals.showViewModal = true;
      this.sign = "far fa-edit";
    },
    editRecord(index, row) {
      this.eIndex = index;
      this.myObj.bookingID = row.bookingID;
      this.myObj.status = row.status;
      this.shouldAdd = false;
      this.optionName = "Update";
      this.modals.showModal = true;
      this.sign = "far fa-edit";
    },
    showRecord(index, row) {
      this.details = true;
      this.eIndex = index;

      var url = this.$store.state.domain + "/bookings/detials/" + row.bookingID;
      axios
        .get(url)
        .then((response) => {
          console.log("BD", response);
          if (response.data === "") {
          } else {
            this.bookingDetails = response.data;
          }
        })
        .catch(function (error) {
          console.error("booking details error", error);
        });
    },
    handleDelete(index, row) {
      console.log("bookingID", row.bookingID);
      swal({
        title: "Are you sure?",
        text: "You want to delete booking # " + row.bookingID + "?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          //Remove API
          var url = this.$store.state.domain + "/bookings/" + row.bookingID;
          console.log("Remove: " + url);
          axios
            .delete(url, qs.stringify(""))
            .then((response) => {
              if (response.data.status === "error") {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: "Request Error! <br />" + response.data.data,
                  type: "danger",
                  icon: "fa fa-ban",
                  timeout: 0,
                });
              } else {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message:
                    'Done! <br />Booking # "' + row.bookingID + '" removed.',
                  type: "danger",
                  icon: "fa fa-check",
                  timeout: this.$store.state.timeout,
                });

                this.deleteRow(row);
              }
            })
            .catch(function (error) {
              this.$notify({
                verticalAlign: "bottom",
                horizontalAlign: "center",
                message: "Request Error! <br />" + response.data.data,
                type: "danger",
                icon: "fa fa-ban",
                timeout: 0,
              });
            });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.bookingID === row.bookingID
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
  computed: {
    getData() {
      return this.$store.state.gridData;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
